/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useState } from "react";
import { RESOURCE_MODULE_IDS, RESOURCES_CONSTANTS } from "config/constants";
import { INIT_FORM } from "../constants";

const { REASON_FOR_PENALIZE_IDS } = RESOURCES_CONSTANTS;

const useForm = ({
    updatePenaltyDialog, currentPenaltyForm
}) => {
    //#region States
    const [form, setForm] = useState({ ...INIT_FORM });
    //#endregion
    //#region Effects
    useEffect(() => {
        if (!updatePenaltyDialog.value) return;
        setupForm();
    }, [updatePenaltyDialog.value]);
    //#endregion
    //#region Functions
    const setupForm = () => {
        const { 
            id, resourceModule, 
            reasonForPenalize,
            penalizeDays, library,
            details 
        } = currentPenaltyForm;
        const newForm = {
            id, resourceModuleId: resourceModule.id,
            details,
            reasonForPenalizeId: reasonForPenalize.id,
            penalizeDays: penalizeDays === -1 ? "" : penalizeDays,
            ...getLibraryForForm(library)
        };
        setForm({
            ...INIT_FORM,
            ...newForm
        });
    }
    const getLibraryForForm = () => {
        const { reasonForPenalize, library } = currentPenaltyForm;
        if (!library) return {};
        const { resourceType, block } = library;
        return {
            resourceTypeId: resourceType.id,
            penaltyTypeId: reasonForPenalize.id === RESOURCES_CONSTANTS.REASON_FOR_PENALIZE_IDS.NO_REFUND 
                ? RESOURCES_CONSTANTS.PENALTY_TYPE_IDS.EQUIPMENT_REPLACEMENT 
                : 0,
            blockId: block?.id || 0
        };
    }
    const changeField = (field, value) => {
        setForm(prev => ({
            ...prev,
            [field]: typeof value === "function" ? value(prev[field]) : value
        }));
    }
    function areThereChanges() {
        if (!currentPenaltyForm) return false;
        const { 
            resourceModule, reasonForPenalize, library 
        } = currentPenaltyForm;
        switch (resourceModule.id) {
            case RESOURCE_MODULE_IDS.LIBRARY:
                const { block } = library;
                if (reasonForPenalize.id === REASON_FOR_PENALIZE_IDS.NO_REFUND) 
                    return block.id !== form.blockId;
                return penalizeDaysHasBeenModified();
            case RESOURCE_MODULE_IDS.UNIVERSITY_SPACES:
                return penalizeDaysHasBeenModified();
            default: return false;
        }
    }
    function penalizeDaysHasBeenModified() {
        return parseInt(form.penalizeDays) !== parseInt(currentPenaltyForm.penalizeDays);
    }
    function penalizeDaysIsCompleted() {
        return parseInt(form.penalizeDays) > 0;
    }
    function isCompletedForm() {
        const { 
            reasonForPenalizeId, 
            resourceModuleId, blockId
        } = form;
        switch (resourceModuleId) {
            case RESOURCE_MODULE_IDS.LIBRARY:
                if (reasonForPenalizeId === REASON_FOR_PENALIZE_IDS.NO_REFUND) 
                    return Boolean(blockId);
                return penalizeDaysIsCompleted();
            case RESOURCE_MODULE_IDS.UNIVERSITY_SPACES:
                return penalizeDaysIsCompleted();
            default: return false;
        }
    }
    //#endregion
    return {
        value: form,
        change: changeField,
        areThereChanges,
        isCompleted: isCompletedForm
    };
}

export default useForm;